export function web_worker(func: Function, args: object, set_func: React.Dispatch<React.SetStateAction<any>>) {
  const wrapper = () => {
    onmessage = (event: MessageEvent): void => {
      // @ts-ignore
      postMessage(f(JSON.parse(event.data)));
    };
  };

  const worker: Worker = new Worker(
    URL.createObjectURL(
      new Blob([`const f=${func.toString()};(${wrapper.toString()})()`], {
        type: 'application/javascript'
      })
    )
  );

  worker.postMessage(JSON.stringify(args));

  const listener: EventListenerObject = {
    handleEvent: (e: MessageEvent): void => {
      worker.removeEventListener('message', listener);
      worker.terminate();
      try {
        set_func(JSON.parse(e.data));
      } catch {
        set_func(e.data);
      }
    }
  };

  worker.addEventListener('message', listener);
}
